export default __webpack_public_path__ + "static/media/27.2ed6e8e1.jpg";